import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { SecureRoute } from 'components/shared/secure_route';
import { ViewMounter } from '../view_mounter';
import { Panel, PanelPresets, UserPermissionsIds } from '../../utility/enumerations';
// @ts-ignore
// import styles from './myapplications.module.scss';

function ApplicationsContainerScreen() {
  return (
    <div>
      {/* Routes for System Admins */}
      <SecureRoute
        path="/applications/:appType/:id" // Admin -> Application History list
        pathPermissionId={UserPermissionsIds.AccessApplications}
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/my_applications',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={false}
        component={undefined}
      />
      <SecureRoute
        path="/applications/:appType/update-contact-info/:applicantId" // Admin -> Update Contact Info
        pathPermissionId={UserPermissionsIds.AdminSupplyApplications}
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/update_contact_info',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/applications/update-your-mailing-address/:appType/:cardholderIdEncrypted"
        pathPermissionId={UserPermissionsIds.ManageYourInformation}
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/app_history_mailing_address',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />

      <SecureRoute
        path="/applications/update-mailing-address/:appType/:cardholderIdEncrypted"
        pathPermissionId={UserPermissionsIds.AdminSupplyApplications}
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/app_history_mailing_address',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/application/:appType/:id" // Card Applicant -> View Application
        pathPermissionId={UserPermissionsIds.ManageYourInformation}
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/application/application',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <Route
        path="/application/:appType/side_by_side/:id/:from" // -> View HSMV Side-by-side with existing Demographics
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/hsmv/side_by_side',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    empty: state.empty,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationsContainerScreen);
